import { render, staticRenderFns } from "./BMultipleOptionSelection.vue?vue&type=template&id=b2cae8d2"
import script from "./BMultipleOptionSelection.vue?vue&type=script&lang=js"
export * from "./BMultipleOptionSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports